import { useBreakpointValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TooltipHeader } from '$/pages/DashboardPages/components/TooltipHeader';

export const SubCollectionWallsHeader = () => {
  const { t } = useTranslation();

  const exploreText = useBreakpointValue(
    {
      base: t('dashboard.collection.search.wallCoverings'),
      md: t('dashboard.collection.exploreWallCoverings'),
    },
    { ssr: false },
  );

  return (
    <TooltipHeader
      header={exploreText ?? t('dashboard.collection.filter.collection')}
    />
  );
};
